import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class IbcServices {
    constructor(private configService: AppConfigService) {}

    loginIBC(data = {}, nav: any) {
        data["flag"] = 'LoginIbcBean_loginIbc';
        return this.configService.getSSLoginIBC(data, nav);
    }

    balanceIBC(data = {}, nav: any) {
        data["flag"] = 'IbcSportBean_ibcCheckUserBalance';
        return this.configService.getBalanceIBC(data, nav);
    }

    transferBalance(data = {}, nav: any) {
        data["flag"] = 'IbcSportBean_ibcFundTransfer';
        return this.configService.transferBalanceIBC(data, nav);
    }

    loginIBC2(data = {}, nav: any) {
        data["flag"] = 'LoginIbc2Bean_loginIbc';
        return this.configService.getSSLoginIBC(data, nav);
    }

    balanceIBC2(data = {}, nav: any) {
        data["flag"] = 'Ibc2SportBean_ibc2CheckUserBalance';
        return this.configService.getBalanceIBC(data, nav);
    }

    transferBalanceIBC2(data = {}, nav: any) {
        data["flag"] = 'Ibc2SportBean_ibc2FundTransfer';
        return this.configService.transferBalanceIBC(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/ibc.services.ts